
import axiosInstance from '../Services/AxiosInstance';



export const fetchNotifications = async (increment, usertoken) => {
  try {
    const payload = {
      offset: increment
    };

    const response = await axiosInstance.post(`/notify/user`, payload);

    return response;
  } catch (error) {
    throw error;
  }
};



export const CheckNewNotification = async (usertoken) => {
  try {


    const response = await axiosInstance.post(`/notify/getNotification`, {});
    return response

  } catch (error) {

    throw error;
  }
};